import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import type { PrioritisationT } from '@mentimeter/question-modules-types';
import { PrioritisationPresentation } from './PrioritisationPresentation';

export function PrioritisationPresentationDataHandler() {
  const { useQuestion, InteractiveCanvasComponents, useConfig, useResults } =
    usePresentationContext();

  const { enableAnimations } = useConfig();
  const { results = [] } = useResults<PrioritisationT>();

  const question = useQuestion();
  return (
    <PrioritisationPresentation
      question={question}
      shouldAnimate={enableAnimations}
      results={results}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
    />
  );
}
